/**
 * Shared dashboard family and assignable RBAC role types.
 */

export { RbacRoleId } from "@risalabs_frontend_org/auth-wrapper";
export type { AssignableRoleId } from "@risalabs_frontend_org/auth-wrapper";

/**
 * Dashboard families supported by facility configuration and RBAC routing.
 */
export type ConfigSectionType =
  | "med_onc"
  | "pharmacy"
  | "claims"
  | "clinical_trials";

export const CONFIG_SECTION_TYPES: ConfigSectionType[] = [
  "med_onc",
  "pharmacy",
  "claims",
  "clinical_trials",
];
